import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { LoginService } from "src/app/login/login.service";

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    providers:[MessageService]
})
export class SettingsComponent implements OnInit {
    public selectedLanguage: any;

    public languages = [
        {
            id: 1,
            name: "English",
        },
        {
            id: 2,
            name: "Deutsch",
        },
        {
            id: 3,
            name: "Français",
        },
        {
            id: 4,
            name: "Italiano",
        },
        {
            id: 5,
            name: "Español",
        },
        {
            id: 6,
            name: "Nederlands",
        },
        {
            id: 7,
            name: "Türkçe",
        },
        {
            id: 8,
            name: "Русский",
        },
        {
            id: 9,
            name: "Português",
        },
    ];

    constructor(
        private loginService: LoginService,
        private messageService: MessageService
    ) {}


    ngOnInit(): void {
        this.filteredLanguages = this.languages;
    }

    savePass(p1: string, p2: string) {
        if (p1 !== p2 || p1.length < 6 || p2.length < 6) {
            this.messageService.add({
                key: "tc",
                severity: "error",
                summary: "Please correct passwords",
                detail: "Passwords are empty, password are not the same or passwords are less than 6 characters. Min. 6 characters are required.",
            });
            //fancy style errormessage

            return;
        }
        this.loginService.changepass(p1,p2).subscribe((x) =>
            this.messageService.add({
                key: "tc",
                severity: "success",
                summary: "Done",
                detail: "Password was succesfully changed.",
            }), (response)=>{
                this.messageService.add({
                    key: "tc",
                    severity: "error",
                    summary: "Error",
                    detail: response.error.error,
                })}

        );
    }

    saveLang() {
        if (this.selectedLanguage != null) {
            this.loginService
                .changelang(this.selectedLanguage.id)
                .subscribe((x) =>
                    this.messageService.add({
                        key: "tc",
                        severity: "success",
                        summary: "Done",
                        detail: "Settings were changed.",
                    }),
                    (error)=>{
                        this.messageService.add({
                            key: "tc",
                            severity: "error",
                            summary: "Error",
                            detail: "Change can not be done. Please contact the site administrator.",
                        })}
                );
        } else {
            this.messageService.add({
                key: "tc",
                severity: "error",
                summary: "Language Selection",
                detail: "Please select a language. Setting are NOT updated.",
            });
        }
    }

    public filteredLanguages: any[];

    filterLanguages(event) {
        const filtered: any[] = [];
        const query = event.query;
        this.languages.forEach((e) => {
            if (e.name.toLowerCase().indexOf(query.toLowerCase()) == 0)
                filtered.push(e);
        });
        this.filteredLanguages = filtered;
    }
}
